import React from 'react'
import Privacy from '../components/privacy-policy'

export default function PrivacyPolicy() {
    return <Privacy />
}
